/**
 * MotionOpenButton - Shared button for opening motion overlays
 * Used by both TimeMotionSettings and PlanetMovementSettings (DRY)
 */

import React from 'react';
import { Button } from '@chakra-ui/react';
import { Play } from 'lucide-react';

interface MotionOpenButtonProps {
  isActive: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export const MotionOpenButton: React.FC<MotionOpenButtonProps> = ({
  isActive,
  disabled = false,
  onClick,
}) => {
  return (
    <Button
      size="xs"
      colorScheme={isActive ? 'gray' : 'blue'}
      variant={isActive ? 'outline' : 'solid'}
      leftIcon={isActive ? undefined : <Play size={12} />}
      onClick={onClick}
      isDisabled={disabled || isActive}
      opacity={isActive ? 0.6 : 1}
    >
      {isActive ? 'Active' : 'Open'}
    </Button>
  );
};

export default MotionOpenButton;
